import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import { WorkState } from './types';
import api from '@/api';
import * as workRequests from '@/api/requests/work/work';
import {
    WorkMediaCreateRequestPayload,
    WorkMediaDeleteRequestPayload,
    WorkMediaUpdateRequestPayload
} from '@/store/modules/work/types';
import { MediaResource } from '@/api/requests/types';

export const actions: ActionTree<WorkState, RootState> = {

    /**
     * Fetch all works.
     *
     * @param commit
     * @param getters
     */
     async fetchWorks({ commit, getters }) {
        const response = await api.call(workRequests.ALL(getters.httpFilters));
        commit('setWorks', response.data.data);
    },

    /**
     * Fetch single work.
     *
     * @param commit
     * @param getters
     */
    async fetchWork({ commit, getters }, workId: number) {
        const response = await api.call(workRequests.FIND(workId));
        commit('setSelectedWork', response.data.data);
    },

    /**
     * Set filters.
     *
     * @param commit
     * @param dispatch
     * @param filters
     */
    setFilters({ commit }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
    },

    /**
     * Add a media to a work.
     *
     * @param commit
     * @param workId
     * @param file
     */
    async addMediaToWork({ commit }, { workId, file }: WorkMediaCreateRequestPayload) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.call(workRequests.ADD_MEDIA(workId, formData, (progressEvent) => {
            // TODO: gestione progress upload.
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }));
        commit('addMediaToWork', { workId, media: response.data.data });
    },

    /**
     * Update a media into a work.
     *
     * @param commit
     * @param workId
     * @param mediaId
     * @param media
     */
    async updateMediaIntoWork({ commit }, { workId, mediaId, media }: WorkMediaUpdateRequestPayload) {
        const response = await api.call(workRequests.UPDATE_MEDIA(workId, mediaId, media));
        commit('addMediaToWork', { workId, media: response.data.data });
    },

    /**
     * Remove a media from a work.
     *
     * @param commit
     * @param workId
     * @param mediaId
     */
    async removeMediaFromWork({ commit }, { workId, mediaId }: WorkMediaDeleteRequestPayload) {
        await api.call(workRequests.REMOVE_MEDIA(workId, mediaId));
        commit('removeMediaFromWork', { workId, mediaId });
    },

    /**
     * Download a media of a work.
     *
     * @param commit
     * @param getters
     * @param workId
     * @param mediaId
     */
    async downloadMediaOfWork({ state, commit, getters }, { workId, mediaId }: WorkMediaDeleteRequestPayload) {
        if (!state.selectedWork) {
            throw new Error('No work selected');
        }

        // Retrieve media
        const media = state.selectedWork.media.find((item: MediaResource) => item.id === mediaId);

        if (!media) {
            throw new Error('No media to download');
        }

        const response = await api.call(workRequests.DOWNLOAD_MEDIA(workId, mediaId));
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', media.fileName);
        document.body.appendChild(link);
        link.click();
    },

};
